module.exports = __webpack_public_path__ + "static/img/s95.7ed9a275.png";